import { render, staticRenderFns } from "./AccessRelatory.vue?vue&type=template&id=c1a5506a&scoped=true"
import script from "./AccessRelatory.vue?vue&type=script&lang=js"
export * from "./AccessRelatory.vue?vue&type=script&lang=js"
import style0 from "./AccessRelatory.vue?vue&type=style&index=0&id=c1a5506a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a5506a",
  null
  
)

export default component.exports